import { useNavigate } from 'react-router-dom';
import { Wallet, Home } from 'lucide-react';
import { pluralCredits } from '@masha/shared';
import { usePricing } from '../lib/pricing';
import { Button } from './ui';

export function PaywallView() {
  const navigate = useNavigate();
  const pricing = usePricing();
  return (
    <div className="min-h-screen p-6 max-w-lg mx-auto flex flex-col items-center justify-center text-center safe-top safe-bottom">
      <div className="w-16 h-16 rounded-2xl bg-warning-subtle text-warning flex items-center justify-center mb-4">
        <Wallet size={28} />
      </div>
      <h1 className="text-xl font-bold mb-2">Не хватает кредитов</h1>
      <p className="text-sm text-tg-hint mb-6 max-w-xs">
        Чтобы создать сценарий, пополните баланс. Сценарий стоит {pricing.reels}{' '}
        {pluralCredits(pricing.reels)}, первая переделка бесплатно.
      </p>
      <Button
        onClick={() => navigate('/balance')}
        variant="primary"
        size="lg"
        leftIcon={<Wallet size={18} />}
        className="w-full max-w-xs mb-2"
      >
        Пополнить
      </Button>
      <Button
        onClick={() => navigate('/')}
        variant="secondary"
        size="lg"
        leftIcon={<Home size={18} />}
        className="w-full max-w-xs"
        hapticKind="light"
      >
        На главную
      </Button>
    </div>
  );
}
